import { render } from "./museumCourseList.vue?vue&type=template&id=5c871746&scoped=true"
import script from "./museumCourseList.vue?vue&type=script&lang=js"
export * from "./museumCourseList.vue?vue&type=script&lang=js"

import "./museumCourseList.vue?vue&type=style&index=0&id=5c871746&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c871746"]])

export default __exports__